<template>
  <div :class="['vip_swiper', isCenter && 'is-center']">
    <swiper class="vip_card_swiper" ref="vipSwiperRef" :options="swiperOptions"
      @slideChange="handleChange" @sliderMove="handleTransition" @slideChangeTransitionEnd="handleAnimationFinish">
      <swiper-slide v-for="(item, index) in bannerImagePath" :key="`${item.level || index}-${index}`">
        <div class="vip_slide" @click="goVipDetail">
          <div :class="['vip_card', index === currentvipIndex && 'is-active', item.is_current && 'is-current']" :style="getCardStyle(index, item)">
            <div class="vip_card_inner">
              <div class="vip_card_main">
                <div class="vip_title"> </div>
                <img v-if="userLevelInfo.grading_status && item.is_current" class="vip_keep_badge" :src="require('@/assets/image/member1/bao.png')" />
                <div class="vip_growth" :style="{ color: color }">成长值{{ growthValue }}</div>
                <div class="vip_desc_row" :style="{ color: color }">
                  <span class="vip_desc">{{ getDesc(item, index) }}</span>
                </div>
                <div class="vip_bottom_row" v-if="!isMaxLevel">
                  <div class="vip_progress_track" :style="{
                    background: addAlpha(color, 0.2),
                  }">
                    <div class="vip_progress_fill" :style="getProgressStyle(index, item)"></div>
                  </div>
                </div>
                <div class="vip_expire" :style="{ color: color }">{{ getExpireText(item) }}</div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>

    <div class="vip_level_scale">
      <div class="vip_level_scale_inner">
        <div v-for="(item, index) in bannerImagePath" :key="`scale-${item.level || index}-${index}`"
          :class="['vip_level_scale_item', index === currentvipIndex && 'is-active', item.achieve && 'is-achieved']"
          @click="tapScale(index)" :style="{
            color: index !== currentvipIndex ? addAlpha(color, 0.5) : color,
          }">
          <span>{{ `v${item.level || index}` }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { vipList } from "@/api/member.js"

export default {
  props: {
    game_id: {
      type: [String, Number],
      default: '0'
    },
    isCenter: {
      type: Boolean,
      default: false
    },
    level: {
      type: [String, Number],
      default: '0'
    },
    disableTouch: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: '#fff'
    },
    growthValue: {
      default: 0
    },
    userLevelInfo: {
      default: {}
    }
  },
  data() {
    return {
      bannerImagePath: [],
      currentvipIndex: 0,
      uservip: 0,
      itemWidth: 0
    }
  },
  computed: {
    marginPx() {
      const screenWidth = window.innerWidth || 375
      return screenWidth >= 768 ? 60 : 13
    },
    swiperOptions() {
      return {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: this.marginPx * 2,
        initialSlide: this.currentvipIndex,
        speed: 320,
        allowTouchMove: !this.disableTouch && !this.isCenter,
        observer: true,
        observeParents: true,
      }
    },
    isMaxLevel() {
      return this.level === this.bannerImagePath.length - 1
    }
  },
  watch: {
    currentvipIndex(val) {
      const swiper = this.$refs.vipSwiperRef && this.$refs.vipSwiperRef.swiper
      if (swiper && swiper.activeIndex !== val) {
        swiper.slideTo(val)
      }
    }
  },
  mounted() {
    this.loadVipList()
  },
  methods: {
    refreshVipList() {
      this.loadVipList({ keepCurrentIndex: true })
    },
    sanitizeAsset(value) {
      if (!value) return ''
      return String(value).replace(/^[`\s]+|[`\s]+$/g, '')
    },
    parseBgColor(bgColor) {
      if (!bgColor) return {}
      if (typeof bgColor === 'object') return bgColor || {}
      const normalized = String(bgColor).trim()
      if (!normalized || normalized === '{}' || normalized === 'null') return {}
      try {
        return JSON.parse(normalized) || {}
      } catch (error) {
        return {}
      }
    },
    buildThemeFromItem(item, index) {
      const bgColor = this.parseBgColor(item && item.bg_color)
      const topColor = bgColor.top_color || ''
      const bottomColor = bgColor.bottom_color || ''
      const benefitBgColor = this.sanitizeAsset(item && item.benefit_bg_color)
      return {
        index,
        color: benefitBgColor || this.color,
        background: topColor && bottomColor
          ? `linear-gradient(360deg, ${bottomColor} 12.33%, ${topColor} 100%)`
          : '',
        accentSoft: topColor ? this.addAlpha(topColor, 0.16) : '',
        lightCore: topColor ? this.addAlpha(topColor, 0.30) : '',
        lightSoft: topColor ? this.addAlpha(topColor, 0.18) : '',
        lightEdge: bottomColor ? this.addAlpha(bottomColor, 0.10) : '',
      }
    },
    normalizeVipItem(item, index) {
      const image = this.sanitizeAsset(item && item.image)
      const levelImage = this.sanitizeAsset(item && item.level_image) || image
      const levelBadge = this.sanitizeAsset(item && item.level_badge)
      const giftBadge = this.sanitizeAsset(item && item.gift_badge)
      const percentage = Number(item && item.percentage)
      return {
        ...item,
        level: Number(item && item.level) || 0,
        growth_value: Number(item && item.growth_value) || 0,
        level_image: levelImage,
        level_badge: levelBadge,
        gift_badge: giftBadge,
        benefit_bg_color: this.sanitizeAsset(item && item.benefit_bg_color),
        retain_status: Number(item && item.retain_status) || 0,
        retain_growth_value: Number(item && item.retain_growth_value) || 0,
        retain_extend_time: Number(item && item.retain_extend_time) || 0,
        image,
        is_current: Boolean(item && item.is_current),
        expiration_date: this.sanitizeAsset(item && item.expiration_date),
        achieve: Boolean(item && item.achieve),
        diff_growth_value: Number(item && item.diff_growth_value) || 0,
        percentage: Number.isFinite(percentage) ? percentage : null,
        theme: this.buildThemeFromItem(item, index),
      }
    },
    getTheme(index) {
      const item = this.bannerImagePath[index] || {}
      return item.theme || this.buildThemeFromItem(item, index)
    },
    emitThemeChange(index) {
      const theme = this.getTheme(index)
      if (!theme) return
      this.$emit('themeChange', {
        index,
        color: theme.color,
        background: theme.background,
        accentSoft: theme.accentSoft,
        lightCore: theme.lightCore,
        lightSoft: theme.lightSoft,
        lightEdge: theme.lightEdge,
      })
    },
    getCardStyle(index, item) {
      const image = item.level_image || '/static/image/member1/v0'
      const cardStyle = {}
      if (image) {
        cardStyle.backgroundImage = `url(${image})`
        cardStyle.backgroundSize = 'cover'
        cardStyle.backgroundPosition = 'center'
        cardStyle.backgroundRepeat = 'no-repeat'
      }
      const theme = this.getTheme(index)
      if (!cardStyle.backgroundImage && theme && theme.background) {
        cardStyle.background = theme.background
      }
      return cardStyle
    },
    getProgressStyle(index, item) {
      const percentage = this.growthValue / item.diff_growth_value * 100

      return {
        width: `${percentage}%`,
        background: this.color,
      }
    },
    getStatusText(item) {
      if (item.is_current && item.achieve) return '当前等级'
      if (item.achieve) return '已解锁'
      return '待解锁'
    },
    getNextTitle(index) {
      if (index >= this.bannerImagePath.length - 1) return '最高等级'
      const nextItem = this.bannerImagePath[index + 1] || {}
      if ((nextItem.level || 0) === 0) return 'VIP0'
      return `VIP${nextItem.level}`
    },
    getDesc(item, index) {
      if (item.achieve && !item.is_current) return '已达到该等级'
      if (item.is_current && Number(item.diff_growth_value) > 0) {
        return `还需 ${item.diff_growth_value} 成长值升级至 ${this.getNextTitle(index)}`
      }
      if (this.isMaxLevel) {
        return '已达最高等级'
      }
      return `还需 ${item.diff_growth_value || 0} 成长值升级至VIP${item.level}`
    },
    getExpireText(item) {
      if (item.achieve && !item.is_current) return ''
      if (!item.is_current && !item.achieve) return '待升级'
      if (!item.expiration_date) return ''
      const dateText = String(item.expiration_date).split(' ')[0] || ''
      const parts = dateText.split('-')
      return `${parts[0]}年${parts[1]}月${parts[2]}日 过期`
    },
    getLevelVisual(item, index) {
      if ((item.level || 0) === 0) return '0'
      return item.level || index
    },
    getDomWidth() {
      const el = this.$el.querySelector('.vip_card.is-active')
      if (el) {
        const rect = el.getBoundingClientRect()
        if (rect && rect.width) {
          this.itemWidth = rect.width
        }
      }
    },
    handleAnimationFinish() {
      this.$nextTick(() => {
        this.getDomWidth()
      })
    },
    handleTransition() {
      const swiper = this.$refs.vipSwiperRef && this.$refs.vipSwiperRef.swiper
      const translate = swiper ? swiper.translate || 0 : 0
      const dx = translate + this.currentvipIndex * this.itemWidth
      this.$emit('swipertransition', dx, this.itemWidth)
    },
    handleChange() {
      const swiper = this.$refs.vipSwiperRef && this.$refs.vipSwiperRef.swiper
      if (!swiper) return
      this.currentvipIndex = swiper.activeIndex
      this.$emit('changeIndex', this.currentvipIndex)
      this.emitThemeChange(this.currentvipIndex)
      this.$nextTick(() => {
        this.getDomWidth()
      })
    },
    tapScale(index) {
      if (this.disableTouch || this.isCenter) return
      this.currentvipIndex = index
      this.$emit('changeIndex', this.currentvipIndex)
      this.emitThemeChange(this.currentvipIndex)
      this.$emit('swipertransition', this.currentvipIndex * this.itemWidth, this.itemWidth)
    },
    goVipDetail() {
      this.$router.push('/pages/member/benefitIntro')
    },
    async loadVipList(options = {}) {
      const { keepCurrentIndex = false } = options
      const query = {}
      const level = Number(this.level)
      if (Number.isFinite(level) && level >= 0) {
        query.level = level
      }
      const res = await vipList(query)
      const list = Array.isArray(res && res.data) ? res.data : []
      this.bannerImagePath = list.map((item, index) => this.normalizeVipItem(item, index))
      const currentIndex = this.bannerImagePath.findIndex(item => item.is_current)
      const achievedIndex = this.bannerImagePath.reduce((result, item, index) => {
        return item.achieve ? index : result
      }, -1)
      const initialIndex = currentIndex > -1 ? currentIndex : (achievedIndex > -1 ? achievedIndex : 0)
      const maxIndex = Math.max(this.bannerImagePath.length - 1, 0)
      this.currentvipIndex = keepCurrentIndex
        ? Math.min(this.currentvipIndex, maxIndex)
        : initialIndex
      this.uservip = achievedIndex > -1 ? achievedIndex : initialIndex
      this.$emit('getuserCurrentVip', this.uservip, this.currentvipIndex)
      this.emitThemeChange(this.currentvipIndex)
      this.$nextTick(() => {
        setTimeout(() => {
          this.getDomWidth()
          this.$emit('swipertransition', this.currentvipIndex * this.itemWidth, this.itemWidth)
          this.$emit('layoutReady')
        }, 60)
      })
    },
    addAlpha(color, alpha = 0.2) {
      if (!color) return `rgba(0,0,0,${alpha})`
      const normalizedColor = String(color).trim()
      if (/^#([0-9a-fA-F]{3})$/.test(normalizedColor)) {
        const hex = normalizedColor.slice(1).split('').map(s => s + s).join('')
        const r = parseInt(hex.slice(0, 2), 16)
        const g = parseInt(hex.slice(2, 4), 16)
        const b = parseInt(hex.slice(4, 6), 16)
        return `rgba(${r}, ${g}, ${b}, ${alpha})`
      }
      if (/^#([0-9a-fA-F]{6})$/.test(normalizedColor)) {
        const hex = normalizedColor.slice(1)
        const r = parseInt(hex.slice(0, 2), 16)
        const g = parseInt(hex.slice(2, 4), 16)
        const b = parseInt(hex.slice(4, 6), 16)
        return `rgba(${r}, ${g}, ${b}, ${alpha})`
      }
      if (/^rgba?\(/i.test(normalizedColor)) {
        const match = normalizedColor.match(/^rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)(?:\s*,\s*[\d.]+\s*)?\)$/i)
        if (match) {
          return `rgba(${match[1]}, ${match[2]}, ${match[3]}, ${alpha})`
        }
      }
      return normalizedColor
    }
  }
}
</script>


<style lang="scss" scoped>
.vip_swiper {
  width: 100%;
  padding-top: .35rem;
  padding-bottom: .25rem;
}

.vip_card_swiper {
  width: 100%;
  height: 7.5rem;
}

.vip_slide {
  height: 100%;
  padding: 0 .8rem;
  box-sizing: border-box;
}

.vip_card {
  position: relative;
  width: 100%;
  height: 7.3rem;
  overflow: hidden;
  border-radius: .7rem;
  transform: scale(0.94) translateY(.25rem);
  opacity: 0.7;
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.vip_card.is-active {
  transform: scale(1);
  opacity: 1;
}
.vip_card_inner {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  height: 100%;
  padding: .85rem .65rem .6rem;
  box-sizing: border-box;
}

.vip_card_main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  min-width: 0;
  color: #f5f8ff;
  position: relative;
}

.vip_title {
  display: flex;
  align-items: center;
  height: 1.5rem;
}

.vip_level_badge {
  height: 1.1rem;
  max-width: 6rem;
}

.vip_level_text {
  color: #ffffff;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1;
}

.vip_keep_badge {
  position: absolute !important;
  top: 1.2rem;
  left: 30%;
  width: 3.15rem;
  display: block;
  flex: none;
}

.vip_growth {
  margin-top: 1.5rem;
  font-size: .6rem;
  line-height: 1.2;
}

.vip_desc_row {
  margin-top: .45rem;
}

.vip_desc {
  font-size: .6rem;
  line-height: 1.55;
}

.vip_bottom_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0;
}

.vip_progress_track {
  width: 9.75rem;
  height: .1rem;
  overflow: hidden;
  border-radius: 25rem;
}

.vip_progress_fill {
  height: 100%;
  border-radius: 25rem;
}

.vip_expire {
  position: absolute;
  right: .15rem;
  bottom: .05rem;
  margin-left: .4rem;
  font-size: .5rem;
  line-height: 1.2;
  white-space: nowrap;
}

.vip_level_scale {
  width: 100%;
  margin-top: .45rem;
  white-space: nowrap;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
}

.vip_level_scale_inner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 100%;
  padding: 0 .85rem;
  box-sizing: border-box;
}

.vip_level_scale_item {
  position: relative;
  flex: none;
  margin-right: .45rem;
  padding-bottom: .25rem;
  font-size: .6rem;
  line-height: 1;
  text-transform: lowercase;
}

.vip_level_scale_item.is-achieved {
  color: rgba(94, 120, 147, 0.74);
}

.vip_level_scale_item.is-active {
  color: #9bbee5;
}

.vip_swiper.is-center {
  padding-top: 0;
}

.vip_swiper.is-center .vip_card_swiper {
  height: 7.5rem;
}

.vip_swiper.is-center .vip_card {
  height: 6.7rem;
}

.vip_swiper.is-center .vip_title {
  font-size: 1.2rem;
}

.vip_swiper.is-center .vip_visual_plate {
  height: 3.7rem;
}

.vip_swiper.is-center .vip_visual_level {
  font-size: 2.4rem;
}
</style>
